import React from "react";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import {
  dashboard2SectionFieldsetLegendDescriptionSx,
  dashboard2SectionFieldsetLegendSx,
  dashboard2SectionFieldsetLegendTitleSx
} from "../dashboard2-status.styles";

type Dashboard2SectionFieldsetLegendProps = {
  id?: string;
  icon: React.ReactNode;
  title: string;
  description?: string;
  legendSx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  "data-testid"?: string;
};

export const Dashboard2SectionFieldsetLegend: React.FC<Dashboard2SectionFieldsetLegendProps> = ({
  id,
  icon,
  title,
  description,
  legendSx,
  iconSx,
  titleSx,
  "data-testid": testId
}) => (
  <Box
    id={id}
    sx={{
      ...(dashboard2SectionFieldsetLegendSx as object),
      ...(legendSx as object)
    }}
    data-testid={testId}
  >
    <Box sx={iconSx} aria-hidden>
      {icon}
    </Box>
    <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", gap: 0.125 }}>
      <Typography
        component="span"
        variant="inherit"
        sx={{
          ...(dashboard2SectionFieldsetLegendTitleSx as object),
          ...(titleSx as object)
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          component="span"
          variant="inherit"
          sx={dashboard2SectionFieldsetLegendDescriptionSx}
        >
          {description}
        </Typography>
      )}
    </Box>
  </Box>
);
